import { FunctionComponent } from 'react'
import { useNavigate } from 'react-router'
import { Button, Form, Spinner } from 'react-bootstrap'
import Icon from 'components/ui/icon'

import CheckRow from 'components/ui/checkRow'
import { formatCNPJ } from '../../../utilities/cnpj.util'
import { NewHospital } from '../types'

type HospitalFormProps = {
  hospital: NewHospital
  onChange: (changes: Partial<NewHospital>) => void
  onSubmit: (event: React.ChangeEvent<HTMLFormElement>) => void
  validated: boolean
  saving: boolean
}

/** Hospital data card shared by the add and edit pages. */
const HospitalForm: FunctionComponent<HospitalFormProps> = ({
  hospital,
  onChange,
  onSubmit,
  validated,
  saving,
}) => {
  const navigate = useNavigate()

  return (
    <Form
      noValidate
      validated={validated}
      onSubmit={onSubmit}
      className="card"
      style={{ maxWidth: '48rem' }}
    >
      <div className="card-head">
        <h2 className="card-title">Dados do hospital</h2>
      </div>

      <div className="card-body">
        <div className="form-grid form-grid-2">
          <Form.Group controlId="formNome">
            <Form.Label>Nome</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nome"
              name="name"
              value={hospital.name}
              onChange={(event) => onChange({ name: event.target.value })}
              required
            />
            <Form.Control.Feedback type="invalid">
              Informe o nome do hospital.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formCNPJ">
            <Form.Label>CNPJ</Form.Label>
            <Form.Control
              type="text"
              placeholder="00.000.000/0000-00"
              name="cnpj"
              value={formatCNPJ(hospital.cnpj)}
              onChange={(event) => onChange({ cnpj: event.target.value })}
              minLength={18}
              maxLength={18}
              required
            />
            <Form.Control.Feedback type="invalid">
              Informe um CNPJ válido.
            </Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="mt-4">
          <CheckRow
            id="formHospitalAtivo"
            checked={hospital.enabled}
            onChange={(enabled) => onChange({ enabled })}
            title="Hospital ativo"
            description="Só habilite após a integração ser validada pela equipe de desenvolvimento."
          />
        </div>
      </div>

      <div className="card-foot">
        <Button variant="secondary" onClick={() => navigate('/hospitals')}>
          Cancelar
        </Button>
        <Button variant="primary" type="submit">
          {saving ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Icon name="check" size={16} />
          )}
          Salvar
        </Button>
      </div>
    </Form>
  )
}

export default HospitalForm
